/**
 * The x-axis helpers the built-in data presets share: a day range as epoch
 * milliseconds (`BY_MSE`) or days (`BY_DSE`), and the matching axis labels.
 * Package-internal.
 */
import {
  DateTime,
  DaysSinceEpoch,
  MsSinceEpoch,
  NaiveDate,
  TimeOfDay,
  TimezoneRegion,
  Utc,
} from "@tento-chrono";

export const BY_MSE = (r: NaiveDate.Range, tz: TimezoneRegion) => ({
  start: tz.toWallClock(r.start.withTime(TimeOfDay.ZERO)).mse,
  end: tz.toWallClock(r.end.withTime(TimeOfDay.ZERO)).mse,
});

export const BY_DSE = (r: NaiveDate.Range) => ({
  start: r.start.dse,
  end: r.end.dse,
});

export function mseDisplay(x: number, tz: TimezoneRegion): string {
  const dt = DateTime.fromMse(MsSinceEpoch.of(x), Utc);
  const local = tz.toTz(dt);
  return local.ndt.toString().slice(0, 16).replace("T", " ");
}

export function dseDisplay(x: number): string {
  return NaiveDate.fromDse(x as DaysSinceEpoch).toString();
}
